import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet, Platform } from "react-native";

import { durationToHHmm } from "../../../helpers/utils";
import AppTheme from "../AppTheme";

export default function ManaHourMinutes({ duration, center = true, showPlusSign = false }) {
  const [time, setTime] = useState({});

  useEffect(() => {
    setTime(durationToHHmm(duration || 0));
  }, [duration]);

  return (
    <View style={styles.numbers}>
      <Text style={styles.hoursText}>
        {showPlusSign && time.sign === "" ? "+" : time.sign}
        {time.hours}
      </Text>
      <Text style={[styles.minutesText]}>
        {time.minutes > 0 ? time.minutes : ""}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  numbers: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "row",
  },
  minutesText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 7,
    lineHeight: 9,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  hoursText: {
    textAlign: "center",
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
